module.exports = __webpack_public_path__ + "img/light.1977c3af.jpg";